import { useState, useEffect, useRef } from "react";
import { Formik, setFieldValue, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Controls from "../../components/FormsUI";
import { useAuth } from "../../utility/auth";
import ImagePreview from "../../components/FormsUI/PreviewImage/index";
import DoctorController from "../../controller/DoctorController";
import MasterController from "../../controller/MastersController";
import CustomizedSnackbars from "../../components/Alert";
import EditIcon from "@mui/icons-material/Edit";
import Load from "../../components/FormsUI/Loader/index";//../components/FormsUI/Loader/index
import DeleteIcon from "@mui/icons-material/Delete";
import "../../css/style.css";
import { tokens } from "../../theme";
import {
  Container,
  Grid,
  useTheme,
  Box,
  Stack,
  IconButton,
} from "@mui/material";
import ExceptionHandlerController from "../../controller/ErrorLogsController";


const INITIAL_FORM_STATE = {
  doctorName: "",
  doctorTitle: "",
  doctorEmail: "",
  doctorMobile: "",
  doctorAddress1: "",
  doctorAddress2: "",
  doctorCity: "",
  doctorState: "",
  doctorPin: "",
  doctorGST: "",
  doctorPAN: "",

  doctorCertificate: null,
};
const FORM_VALIDATION = Yup.object().shape({
  doctorName: Yup.string()
    .matches(/^[A-Za-z ]*$/, "Doctor Name is not in correct format")
    .trim("No white space allowed")
    .strict(true)
    .min(3, "Minimum 3 characters required")
    .max(100, "Doctor Name should not exceed 100 characters")
    .required("Doctor Name is required"),

  doctorTitle: Yup.string()
    .matches(/^[A-Za-z0-9 .]*$/, "Doctor Title is not in correct format")
    .trim("No white space allowed")
    .strict(true)
    .min(2, "Minimum 2 characters required")
    .max(20, "Doctor Title should not exceed 20 characters")
    .required("Doctor Title is required"),

  doctorEmail: Yup.string()
    .email("Doctor Email is not in correct format")
    .trim("No white space allowed")
    .strict(true)
    .required("Doctor Email is required"),

  doctorMobile: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Doctor Mobile is not in correct format")
    .trim("No white space allowed")
    .strict(true)
    .required("Doctor Mobile is required"),
  doctorAddress1: Yup.string()
    .matches(/^[A-Za-z0-9 ]*$/, "Doctor Address1  is not in correct format")
    .trim("No white space allowed")
    .strict(true)
    .min(2, "Minimum 2 characters required")
    .max(200, "Doctor Address1 should not exceed 50 characters")
    .optional(),
  doctorAddress2: Yup.string()
    .matches(/^[A-Za-z0-9 ]*$/, "Doctor Address2  is not in correct format")
    .trim("No white space allowed")
    .strict(true)
    .min(2, "Minimum 2 characters required")
    .max(200, "Doctor Address2 should not exceed 50 characters")
    .optional(),
  doctorCity: Yup.string()
    .matches(/^[A-Za-z0-9 ]*$/, "Doctor City  is not in correct format")
    .trim("No white space allowed")
    .strict(true)
    .min(2, "Minimum 2 characters required")
    .max(20, "Doctor City should not exceed 50 characters")
    .optional(),
  doctorState: Yup.string()
    .matches(/^[A-Za-z0-9 ]*$/, "Doctor State  is not in correct format")
    .trim("No white space allowed")
    .strict(true)
    .min(2, "Minimum 2 characters required")
    .max(20, "Doctor State should not exceed 50 characters")
    .optional(),
  doctorPin: Yup.string()
    .matches(/^[A-Za-z0-9 ]*$/, "Doctor PinCode  is not in correct format")
    .trim("No white space allowed")
    .strict(true)
    .min(2, "Minimum 2 characters required")
    .max(20, "Doctor PinCode should not exceed 50 characters")
    .optional(),
  doctorGST: Yup.string()
    .matches(
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
      "Enter a valid GST number (e.g., 22AAAAA0000A1Z5)"
    )
    // .required("GST number is required"),
    .optional(),
  doctorPAN: Yup.string()
    .matches(
      /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
      "Doctor PAN is not in correct format (e.g., ABCDE1234F)"
    )
    .trim("No white space allowed")
    .strict(true)
    .optional(),
  // .required("Doctor PAN is required"),
  doctorCertificate: Yup.mixed().optional(),

});


let requestType = "";
const Doctor = () => {
  const fileInputRef = useRef(null);
  const doctorController = new DoctorController();
  const masterController = new MasterController();
  const exceptionHandlerController = new ExceptionHandlerController();
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem("user"));
  const { data, token } = user;
  const { userid: userId, tenantid: tenantId } = data.UserInfo;
  const [doctorData, setDoctorData] = useState([])
  const [doctorCertificate, setDoctorCertificateFile] = useState();
  const [popupPreview, setPopUpPreview] = useState({
    doctorCertificate: false
  });
  const previewPopUpImage = (field, value) =>
    setPopUpPreview((prev) => ({ ...prev, [field]: value }));
  const [loader, setLoader] = useState(true);
  const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const [popup, setPopUp] = useState(false);
  const [allUsers, setAllUsers] = useState([]);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  useEffect(() => {
    getAllDoctor();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const getPinCodeData = async (pin, setFieldValue) => {
    let caughtError;
    try {
      const pinData = { pincode: Number(pin) };
      const pinResponse = await masterController.GetLocation(pinData)
      if (pinResponse.status === 200) {
        const pinRes = pinResponse?.data?.body?.pincode;
        setFieldValue("doctorCity", pinRes?.city || "");
        setFieldValue("doctorPin", String(pinRes?.pincode) || "");
        setFieldValue("doctorState", pinRes?.state || "");
      }
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "getPinCodeData",
      };
      exceptionHandlerController.HandleException(logError);
    }
  }

  const getAllDoctor = async () => {
    let caughtError;
    try {
      const response = await doctorController.GetAllDoctor(token);
      if (response.status === 200) {
        const docData = response?.data?.body?.map((item) => ({
          ...item,
          id: item._id,
        }));
        setDoctorData(docData);
      }
      else if (response?.data?.status === 404) {
        showAlert("error", response?.data?.message);
      } else if (response?.status === 500) {
        showAlert("error", response?.response?.data?.message);
      }
      setLoader(() => false);
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "getAllDoctor",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const saveFile = ({ e, setFieldValue, field }) => {
    const file = e.currentTarget.files[0];
    if (!file) return;

    const fileSizeInMB = file.size / (1024 * 1024);
    if (fileSizeInMB > 4) {
      showAlert("error", "Document size should not be more than 4MB");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      return;
    }

    const extFile = getFileExtension(file.name);
    if (!isValidImageExtension(extFile)) return;

    const reader = new FileReader();
    const WIDTH = 1024;
    const IMAGE_H = 682;
    reader.onload = (event) => {
      const image = new Image();
      image.onload = () => {
        const width = image.naturalWidth;
        const height = image.naturalHeight;
        const aspectRatio = width / height;

        const REQUIRED_ASPECT_RATIO = 1024 / 682;
        const TOLERANCE = 0.3;

        if (Math.abs(aspectRatio - REQUIRED_ASPECT_RATIO) > TOLERANCE) {
          showAlert(
            "error",
            `Invalid aspect ratio. Required: ${WIDTH}x${IMAGE_H} (${REQUIRED_ASPECT_RATIO.toFixed(2)})`
          );
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          return;
        }
        // If all checks pass
        setDoctorCertificateFile(event.target.result);
        setFieldValue(field, file);
      };

      image.onerror = () => {
        showAlert("error", "Invalid image file.");
      };

      image.src = event.target.result;
    };

    reader.readAsDataURL(file);
  };

  const getFileExtension = (filename) => {
    return filename.split(".").pop().toLowerCase();
  };
  const isValidImageExtension = (ext) => {
    const validExtensions = ["jpg", "jpeg", "png"];
    if (!validExtensions.includes(ext)) {
      showAlert("error", "Only jpeg, png and jpg images are allowed");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
      return false;
    }
    return true;
  };


  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };

  const columns = [
    {
      headerName: "ID",
      field: "id",
      hide: true,
      filterable: false,
      width: 210,
    },
    { headerName: "Doctor Name", field: "doctorName", width: 210 },
    { headerName: "Doctor Title", field: "doctorTitle", width: 210 },
    { headerName: "Doctor Email", field: "doctorEmail", width: 210 },
    { headerName: "Doctor Mobile", field: "doctorMobile", width: 210 },
    {
      field: "action",
      headerName: "Action",
      width: 210,
      sortable: false,
      filterable: false,
      disableExport: true,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onClick = (e, type) => {
          let caughtError;
          try {
            setAlert({ counter: 0, type: "", msg: "" });
            const currentRow = params?.row;
            if (type === "Edit") {
              requestType = "Edit";
              setUpdatedValues(() => currentRow);
              const currentRowData = currentRow;
              setUpdatedValues(() => currentRowData);
              setDoctorCertificateFile(currentRow.doctorCertificate)
              handleData();
            } else {
              doctorController
                .Delete(currentRow.id, token)
                .then((response) => {
                  if (response.status === 200) {
                    getAllDoctor()
                    showAlert("success", "Deleted successfully");
                    setAllUsers((i) => {
                      return allUsers.filter(
                        (item) => item?.id !== currentRow.id
                      );
                    });
                  } else if (response.data.status === 404) {
                    showAlert("error", response.data.message);
                  }
                  else if (response?.status === 500) {
                    showAlert("error", response?.response?.data?.message);
                  }
                })
                .catch((error) => {
                  showAlert("error", "Oops something went wrong.");
                  setTimeout(() => {
                    setAlert({ counter: 0, type: "", msg: "" });
                  }, 10000);
                });
            }
          } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = { logData, module: "Department onClick(Edit) method" };
            exceptionHandlerController.HandleException(logError);
          }
        };

        return (
          <Stack direction="row" spacing={2}>
            <>
              <IconButton onClick={(e) => onClick(e, "Edit")}>
                <EditIcon type="button" color="primary" id="Edit" />
              </IconButton>
              <IconButton>
                <DeleteIcon
                  type="button"
                  color="secondary"
                  id="Delete"
                  onClick={(e) => onClick(e, "Delete")}
                />
              </IconButton>
            </>
          </Stack>
        );
      },
    },
  ];

  const AddDepartment = async () => {
    // getRolesDD();
    requestType = "Add";
    setUpdatedValues(() => INITIAL_FORM_STATE);
    setDoctorCertificateFile(null)
    handleData();
  };


  const submitValues = (submitValueData) => {
    let submitData = new FormData();
    // tenantId coming from parent/component
    submitData.append("tenantId", tenantId);
    // Map form fields
    submitData.append("doctorName", submitValueData?.doctorName?.trim() ?? "");
    submitData.append("doctorTitle", submitValueData?.doctorTitle?.trim() ?? "");
    submitData.append("doctorEmail", submitValueData?.doctorEmail?.trim() ?? "");
    submitData.append("doctorMobile", submitValueData?.doctorMobile?.trim() ?? "");
    submitData.append("doctorAddress1", submitValueData?.doctorAddress1?.trim() ?? "");
    submitData.append("doctorAddress2", submitValueData?.doctorAddress2?.trim() ?? "");
    submitData.append("doctorCity", submitValueData?.doctorCity?.trim() ?? "");
    submitData.append("doctorState", submitValueData?.doctorState?.trim() ?? "");
    submitData.append("doctorPin", submitValueData?.doctorPin?.trim() ?? "");
    submitData.append("doctorGST", submitValueData?.doctorGST?.trim() ?? "");
    submitData.append("doctorPAN", submitValueData?.doctorPAN?.trim() ?? "");
    submitData.append("doctorCertificate", submitValueData?.doctorCertificate ?? "");

    //add for image
    if (requestType === "Edit") {
      // debugger
      submitData.append("id", submitValueData?.id);
      const id = submitValueData?.id;
      // assuming ID comes from backend
      doctorController
        .Update(id, submitData, token)
        .then((response) => {
          if (response.status === 200) {
            getAllDoctor()
            showAlert("success", response?.data?.message);
            handlePopup(false);
            setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
            // getAllCenters();
          } else {
            if (response?.response?.data?.status === 400)
              showAlert("error", response?.response?.data?.message);
            else if (response?.response?.status === 409)
              showAlert("error", response?.response?.data?.message);
            else if (response?.response?.status === 500)
              showAlert("error", response?.response?.data?.message);

            setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
          }
        })
        .catch((error) => {
          showAlert("error", "Oops something went wrong.");
          setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
        });
    } else {
      doctorController
        .Create(submitData, token)
        .then((response) => {
          if (response?.status === 201) {
            getAllDoctor()
            handlePopup(false);
            showAlert("success", response?.data?.message);
            setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
          } else if (response?.response?.status === 500) {
            showAlert("error", response?.response?.data?.message);
          } else if (response?.response?.status === 400) {
            showAlert("error", response?.response?.data?.message);
          }
          setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
        })
        .catch((error) => {
          showAlert("error", "Oops something went wrong.");
          setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
        });
    }
  };


  const handlePopup = (value) => setPopUp(() => value);
  const handleData = () => setPopUp(() => true);
  if (loader) return <Load />;
  return (
    <>
      <Box
        sx={{
          "& .formBg": {
            border: `1px solid ${colors.grey[900]}`,
            background: `${colors.primary[400]}`,
          },
          "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
          "& .MuiGrid-root.Mui-heading h2": {
            color: `${colors.primary[200]} !important`,
          },
        }}
      >
        <Grid container>
          <Grid className="breadcrumb-section">
            <Grid className="breadcrumb-container">
              <Grid className="Mui-li">
                <nav className="Mui-nav" aria-label="breadcrumb">
                  <ol className="">
                    <li className="MuiBreadcrumbs-li">
                      <h6 className="breadsub">Medical</h6>
                    </li>
                    <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                      /
                    </li>
                    <li className="MuiBreadcrumbs-li">
                      <h6>Doctor</h6>
                    </li>
                  </ol>
                </nav>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} className="adduser">
            <Controls.ActionButton onClick={() => AddDepartment()}>
              <span>Add New</span>
            </Controls.ActionButton>
          </Grid>
          <Grid item xs={12} className="formBg">
            <Container maxWidth="md" className="formClwidth">
              <div>
                <Controls.Grid
                  columns={columns}
                  data={doctorData}
                  fileName={"Users"}
                />
                {popup && (
                  <Controls.Popup
                    title="Doctor Details"
                    openPopup={popup}
                    setOpenPopup={handlePopup}
                  >
                    <Formik
                      enableReinitialize
                      initialValues={{
                        ...(updatedValues || INITIAL_FORM_STATE),
                      }}
                      validationSchema={FORM_VALIDATION}
                      onSubmit={(values) => submitValues(values)}
                    >
                      {({ values, handleChange, setFieldValue }) => (
                        <Form>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="doctorName"
                                label="Doctor Name"
                                type="string"
                                inputProps={{ maxLength: 100 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="doctorTitle"
                                label="Doctor Title"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="doctorMobile"
                                label="Doctor Mobile"
                                type="string"
                                inputProps={{
                                  maxLength: 10,
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                                onChange={(e) => {
                                  const onlyNumbers = e.target.value.replace(/\D/g, ""); // remove non-digits
                                  e.target.value = onlyNumbers;
                                  handleChange(e); // keep Formik in sync
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="doctorEmail"
                                label="Doctor Email"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="doctorPAN"
                                label="Doctor PAN"
                                type="string"
                                inputProps={{
                                  maxLength: 50,
                                  style: { textTransform: "uppercase" }, // UI always shows uppercase
                                }}
                                onInput={(e) => {
                                  e.target.value = e.target.value.toUpperCase();
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="doctorGST"
                                label="Doctor GST"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="doctorPin"
                                label="Doctor PinCode"
                                type="string"
                                inputProps={{ maxLength: 6, inputMode: "numeric", pattern: "[0-9]*" }}
                                onChange={(e) => {
                                  // ✅ allow only digits
                                  const value = e.target.value.replace(/\D/g, ""); // remove non-numeric characters
                                  e.target.value = value; // update input with only digits

                                  handleChange(e); // keep Formik in sync

                                  if (/^\d{6}$/.test(value)) {
                                    getPinCodeData(value, setFieldValue);
                                  }
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="doctorCity"
                                label="Doctor City"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="doctorState"
                                label="Doctor State"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="doctorAddress1"
                                label="Doctor Address1"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="doctorAddress2"
                                label="Doctor Address2"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <h3 className="upload">
                                Certificate Image <span className="asterisk">*</span>
                              </h3>
                              <input
                                type="file"
                                name="doctorCertificate"
                                ref={fileInputRef}
                                onChange={(e) => {
                                  let field = "doctorCertificate";
                                  saveFile({ e, setFieldValue, field });
                                }}
                                className="fileupload"
                                style={{ width: "70%" }}
                              />
                              <Grid className="col-lg-2" style={{ float: "right", marginRight: "1px" }}>
                                {doctorCertificate && (
                                  <img
                                    src={doctorCertificate}
                                    width="55"
                                    style={{ cursor: "pointer" }}
                                    height="55"
                                    onClick={() =>
                                      setPopUpPreview((prev) => ({
                                        ...prev,
                                        doctorCertificate: true,
                                      }))
                                    }
                                    alt="Logo"
                                    className="imgview"
                                  />
                                )}
                                <ImagePreview
                                  image={doctorCertificate}
                                  popup={popupPreview?.doctorCertificate}
                                  field={"doctorCertificate"}
                                  handlePopup={previewPopUpImage}
                                />
                              </Grid>
                              <ErrorMessage name="doctorCertificate">
                                {(msg) => (
                                  <div style={{ color: "#d32f2f" }}>{msg}</div>
                                )}
                              </ErrorMessage>
                            </Grid>
                            <br />
                          </Grid>
                          <Grid item xs={4} md={2} className="marginAuto">
                            <Controls.Button>Submit</Controls.Button>
                          </Grid>
                        </Form>
                      )}
                    </Formik>
                  </Controls.Popup>
                )}
              </div>
            </Container>
          </Grid>
          {alert?.counter > 0 && (
            <CustomizedSnackbars
              status={alert?.counter}
              msg={alert?.msg}
              type={alert?.type}
            />
          )}
        </Grid>
      </Box>
    </>
  );
};

export default Doctor;
